<template>
    <div class="usage-not-result" v-if="listData.length === 0">
      <em class="icon-round-tooltip"></em>
      <span>조회 결과가 없습니다.</span>
    </div>
    <ul v-else>
        <li class="usehistory-item" v-for="(item, index) in listData" :key="index">
           <div @click="toggleReceiptPopup(item.receiptUrl)">
             <div class="save-item-line" v-if="item.imageName && (item.status === 'EXPIRATION' || item.status === 'DISCARD')">
               <img :src="item.imageName" :alt="item.imageAlt" v-if="item.imageName" :class="`thumbnail image-filter`" />
               <span class="save-item-text">만료</span>
             </div>
             <img v-if="item.imageName && item.status !== 'EXPIRATION' && item.status !== 'DISCARD'" :src="item.imageName" :alt="item.imageAlt" :class="`thumbnail`" />
               <div>
                    <em>{{item.text}}</em>
                    <div>
                        <span>{{item.firstDate}}</span>
                        <span>{{item.lastDate}}</span>
                    </div>
               </div>
           </div>
           <div class=usehistory-right-box>
                <strong :class="item.color ? 'price-color' : ''">{{item.price | comma}}</strong>
                <button v-if="item.buttonText && (item.paymentReason === 'RELOAD' || item.paymentReason === 'AUTO_RELOAD') && type === 'charge'" @click.prevent="chargeCancel(item)">{{item.buttonText}}</button>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
  name: 'UseHistory',
  props: ["listData", "type"],
  data () {
    return {
      thumbnail: 'thumbnail'
    }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted(){
  },
  methods: {
    async chargeCancel(item) {
      if(item.buttonText === '취소') {
        this.$emit("charge-popup", [item, true]);
      } else if(item.buttonText === '환불') {
        this.$emit("moveToRefund", item);
      }
    },
    toggleReceiptPopup(receiptUrl) {
      if(receiptUrl) { //영수증 정보 있으면 호출
        this.$emit('toggleReceiptPopup', receiptUrl);
      }
    }
  }

};
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/global.scss';
    .usage-not-result {
      @include flex-center;
      flex-direction: column;
      margin-top: rem(88);
      padding-bottom: calc(env(safe-area-inset-bottom) + rem(88));
      gap: rem(16);
      em { width: rem(30); height: rem(30);}
      span {
        @include font-size(rem(14), 0, 400);
        line-height: normal;
        color: $color-black-100;
      }
    }
    .w-100 { width: rem(100) !important; height: rem(70) !important; }
    .thumbnail {
        display: inline-block;
        width: rem(60);
        height: rem(42);
        margin: 2px rem(12) 2px 0;
        border-radius: rem(6);
    }
    .price-color { color: $color-blue; }
    ul {
        display: flex;
        flex-direction: column;
        gap: 28px;
    }
    .usehistory-item {
        @include flex-between;
        div {
            display: flex;
            div {
                display: flex;
                flex-direction: column;
                em {
                    margin-bottom: rem(4);
                    @include font-size(rem(14), rem(21), 400);
                    letter-spacing: -0.7px;
                    color: $color-black;
                }
                div {
                    display: flex;
                    flex-direction: row;
                    span {
                        @include font-roboto;
                        @include font-size(rem(12), rem(22), 400);
                        letter-spacing: -0.6px;
                        color: $color-gray-700;
                        &:first-child::after {
                            content: "";
                            display: inline-block;
                            margin: 0 rem(4);
                            width: 1px;
                            height: rem(9);
                            background-color: $color-gray-100;
                        }
                    }
                }
            }
        }
    }
    .usehistory-right-box {
        @include flex-between;
        align-items: flex-end;
        flex-direction: column;
        strong {
            @include font-roboto;
            @include font-size(rem(16), rem(23), 500);
            letter-spacing: -0.48px;
            &::after {
                content: '원';
            }
        }
        button {
            @include font-size(rem(14), rem(21), 400);
            color: $color-black-400;
            letter-spacing: -0.7px;
            text-decoration: underline;
        }
    }
    .save-item-line { position: relative;}
    .save-item-text {
      position: absolute;
      top: 49%;
      left: 42%;
      transform: translate( -50%, -50% );
      @include font-size(rem(12), rem(20), 700);
      @include font-roboto;
      color: $color-white;
    }
</style>